import { z } from "zod";
import { CurrencyCode } from "../common/money.js";
import { Timestamp } from "../common/time.js";
import { defineRoute } from "../http/route.js";
/** An indicative rate, as a snapshot records it (ADR 0019): one unit of `base` is `rate` units of `quote`. */
export const ReferenceRate = z
    .object({
    base: CurrencyCode,
    quote: CurrencyCode,
    rate: z.string().regex(/^(0|[1-9]\d*)(\.\d{1,10})?$/),
    source: z
        .string()
        .describe("Where and when it was published, such as `ecb:2026-09-25`; `none` for one currency"),
    capturedAt: Timestamp,
})
    .meta({ id: "ReferenceRate" });
export const getReferenceRate = defineRoute({
    id: "trade.reference_rate.get",
    method: "GET",
    path: "/v1/trade/reference-rate",
    surface: "tenant",
    auth: "user",
    permission: "none",
    marks: [],
    summary: "The indicative rate between two currencies, from the latest reference rates (the ECB's until Airwallex, ADR 0019); `503 FX_UNAVAILABLE` when none is fresher than four days",
    prd: ["PAY-8"],
    request: { query: z.object({ base: CurrencyCode, quote: CurrencyCode }) },
    responses: { 200: { description: "The rate", schema: ReferenceRate } },
    errors: ["AUTH_REQUIRED", "VALIDATION_FAILED", "FX_UNAVAILABLE"],
});
export const referenceRateRoutes = [getReferenceRate];
//# sourceMappingURL=reference-rate.routes.js.map